import { MdGroupWork, MdStars } from 'react-icons/md';
import { TableBadge } from '../../../../../components/TableBadge';
import { NetworkPriceLine } from '../../types';
import styles from './NetworkProductCell.module.scss';

type NetworkProductCellProps = { line: NetworkPriceLine };

export const NetworkProductCell = ({ line }: NetworkProductCellProps) => (
  <div className={styles.container}>
    <div className={styles.codes}>
      <span className={styles.productId}>{line.productId}</span>
      {line.productFamilyId && (
        <>
          {line.itemsCountFamily !== null && (
            <TableBadge className={styles.badge} skin="light-blue">
              <MdGroupWork aria-hidden />
              {line.itemsCountFamily} {line.itemsCountFamily === 1 ? 'ITEM' : 'ITEMS'}
            </TableBadge>
          )}
          <TableBadge className={styles.badge} skin="blue">
            <MdStars aria-hidden />
            {line.productFamilyId}
          </TableBadge>
        </>
      )}
      {line.isProductMaster && (
        <TableBadge className={styles.badge} skin="blue">
          <MdStars aria-hidden />
          PAI
        </TableBadge>
      )}
    </div>
    <p className={styles.description} title={line.description}>
      {line.description}
    </p>
  </div>
);
